import { render, staticRenderFns } from "./CanceledSubscriptionAlert.vue?vue&type=template&id=68f308a3&"
import script from "./CanceledSubscriptionAlert.vue?vue&type=script&lang=js&"
export * from "./CanceledSubscriptionAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports